//Created by wangshuyi on 07/03/2018.

'use strict';
import { createI18n } from 'vue-i18n';

const supportLang = /^(zh|en)$/;
import zh from './zh';
import en from './en';

const i18n = createI18n({
  globalInjection: true,
  locale: supportLang.test(navigator.language) ? navigator.language : 'zh',
  fallbackLocale: 'zh',
  silentTranslationWarn: true,
  messages: {
    zh: zh,
    en: en,
  }
});

export default i18n;
